export const NotariesTypes = [
    { value: 'Registro civil', label: 'Cartório de Registro Civil' },
    { value: 'Registro de imóveis', label: 'Cartório de Registro de Imóveis' },
    { value: 'Notas', label: 'Cartório de Notas' },
    { value: 'Protesto', label: 'Cartório de Protesto' },
    { value: 'Registro de Titulos de documentos', label: 'Cartório de Registro de Títulos e Documentos' },
    { value: 'Outros', label: 'Outros' },
];